import React from 'react'
import styles from './ImageUpload.scss'
import Dropzone from 'react-dropzone'
import cx from 'classnames'
import {FormattedMessage as T} from 'react-intl'

export class ImageUpload extends React.PureComponent {
  static defaultProps = {
    multiple: false,
    disableClick: false
  }

  open = () => {
    this._dropzone && this._dropzone.open()
  }

  render () {
    const {className, onDrop, hintTop: _hintTop, hintBottom: _hintBottom, children, multiple, onClick, disableClick} = this.props

    const defaultHintTop = <T id='ImageUpload.defaultHintTop'
      defaultMessage='Drag to upload image' />

    const hintTop = _hintTop || defaultHintTop

    const defaultHintBottom = <T id='ImageUpload.defaultHintBottom'
      defaultMessage='You can also use the <a>File Browser</a>'
      values={{a: (...chunks) => <a>{chunks}</a>}} />

    const hintBottom = _hintBottom || defaultHintBottom
    return (
      <Dropzone
        ref={r => { this._dropzone = r }}
        style={{}}
        activeStyle={{}}
        rejectStyle={{}}
        disableClick={disableClick}
        onDrop={onDrop}
        accept='image/*'
        className={cx(styles.ImageUpload, className)}
        multiple={multiple}
        activeClassName={styles.active}
        rejectClassName={styles.reject}
        onClick={onClick}>
        <div className={styles.hintTop}>
          {hintTop}
        </div>
        {children}
        <div className={styles.hintBottom}>
          {hintBottom}
        </div>
      </Dropzone>
    )
  }
}
